import {
  Header,
  Sales,
  FeatureContent,
  TopStories,
  Footer,
  Navbar,
  Cart,
} from "./components";
import { headerApi } from "../src/data";
import {
  popularSales,
  topRateSales,
  highlight,
  sneaker,
  story,
  footerAPI,
} from "../src/data";
import { useState } from "react";

function App() {
  const [showCart, setShowCart] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  
  return (
    <>
      <Navbar showCart={showCart} setShowCart={setShowCart} cartItems={cartItems} />
      <Cart showCart={showCart} setShowCart={setShowCart} cartItems={cartItems} setCartItems={setCartItems} />
      <main className="flex flex-col gap-16 ">
        <Header data={headerApi} />
        <Sales cartItems={cartItems} setCartItems={setCartItems} data={popularSales} popular_Sales />
        <FeatureContent data={highlight} highlight />
        <Sales cartItems={cartItems} setCartItems={setCartItems} data={topRateSales} />
        <FeatureContent data={sneaker} />
        <TopStories data={story} />
        <Footer data={footerAPI} />
      </main>
    </>
  );
}

export default App;
